var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CFileInput, {
    attrs: {
      value: _vm.value,
      multiple: false,
      "display-preview": false,
      accept: _vm.accept,
      "max-mb-size": _vm.maxMbSize,
      disabled: _vm.disabled,
    },
    on: {
      input: function ($event) {
        return _setup.emit("input", $event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "uploadTrigger",
        fn: function ({ onFileUpload, disabled: triggerDisabled }) {
          return [
            _c(
              "div",
              {
                staticClass: "framed-row upload-row w-100",
                on: {
                  click: function ($event) {
                    !triggerDisabled && onFileUpload()
                  },
                },
              },
              [
                _c(
                  "span",
                  { staticClass: "upload-thumbnail" },
                  [
                    _vm.imageUrl
                      ? _c("img", { attrs: { src: _vm.imageUrl, alt: "" } })
                      : _c("font-awesome-icon", {
                          attrs: { icon: ["far", "image"] },
                        }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "upload-text" }, [
                  _c("strong", [_vm._v(_vm._s(_vm.name || _vm.placeholder))]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.hint || _setup.defaultHint)),
                  ]),
                ]),
                _vm._v(" "),
                _vm.removable
                  ? _c(_setup.CButton, {
                      attrs: {
                        size: "icon",
                        icon: ["far", "trash-can"],
                        disabled: triggerDisabled,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _setup.emit("remove")
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(_setup.CButton, {
                  attrs: {
                    size: "icon",
                    icon: ["far", "arrow-up-from-bracket"],
                    disabled: triggerDisabled,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return onFileUpload.apply(null, arguments)
                    },
                  },
                }),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }